// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"211":"f1a39409","342":"12f262ef","671":"cb48e577","759":"08942bfd","875":"db947693"}[chunkId] + ".chunk.css";
};